//  // ---------------------- Collection Description Toggle ----------------------
// function truncateHTMLPreserveTags(html, limit) {
//   const tempDiv = document.createElement('div');
//   tempDiv.innerHTML = html;

//   let charCount = 0;
//   let reachedLimit = false;

//   function truncateNode(node) {
//     if (reachedLimit) return null;

//     if (node.nodeType === Node.TEXT_NODE) {
//       if (charCount + node.textContent.length <= limit) {
//         charCount += node.textContent.length;
//         return node.cloneNode();
//       } else {
//         const truncatedText = node.textContent.slice(0, limit - charCount);
//         charCount = limit;
//         reachedLimit = true;
//         return document.createTextNode(truncatedText);
//       }
//     }

//     if (node.nodeType === Node.ELEMENT_NODE) {
//       const clone = node.cloneNode(false);
//       for (let i = 0; i < node.childNodes.length; i++) {
//         const child = truncateNode(node.childNodes[i]);
//         if (child) clone.appendChild(child);
//         if (reachedLimit) break;
//       }
//       return clone;
//     }

//     return null;
//   }

//   const resultFragment = document.createDocumentFragment();
//   for (let i = 0; i < tempDiv.childNodes.length; i++) {
//     const truncated = truncateNode(tempDiv.childNodes[i]);
//     if (truncated) resultFragment.appendChild(truncated);
//     if (reachedLimit) break;
//   }

//   const resultDiv = document.createElement('div');
//   resultDiv.appendChild(resultFragment);
//   return resultDiv.innerHTML.trim();
// }


// const descElement = document.getElementById('collection-description');
// const toggleButton = document.getElementById('toggle-description');

// if (descElement && toggleButton) {
//   const fullHTML = descElement.innerHTML.trim();
//   const isMobile = window.innerWidth <= 768;
//   const charLimit = isMobile ? 100 : 200;

//   // Generate short HTML while keeping tags
//   const shortHTML = truncateHTMLPreserveTags(fullHTML, charLimit);

//   if (fullHTML.length > shortHTML.length) {
//     descElement.setAttribute('data-full-html', fullHTML);
//     descElement.setAttribute('data-short-html', shortHTML);
//     descElement.innerHTML = shortHTML;

//     toggleButton.style.display = 'inline';
//     toggleButton.innerText = 'Read more';

//     let expanded = false;
//     toggleButton.addEventListener('click', function () {
//       if (expanded) {
//         descElement.innerHTML = descElement.getAttribute('data-short-html');
//         toggleButton.innerText = 'Read more';
//       } else {
//         descElement.innerHTML = descElement.getAttribute('data-full-html');
//         toggleButton.innerText = 'Read less';
//       }
//       expanded = !expanded;
//     });
//   }
// }

document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("personalize-name");
  const count = document.getElementById("char-count");
  const checkIcon = document.querySelector(".product-personalization .check-icon");

  if (!input || !count || !checkIcon) return;

  input.addEventListener("input", function () {
    const value = this.value;
    count.innerText = String(value.length);
    if (value.length > 0) {
      checkIcon.classList.remove("hidden");
    } else {
      checkIcon.classList.add("hidden");
    }
  });
});

document.querySelectorAll('.plp-sorting-item input').forEach((sort_input) => {
  const span = sort_input.nextElementSibling;
  if (span && span.tagName === 'SPAN') {
    span.addEventListener('click', () => sort_input.click());
  }
});